import { Reducer } from '@reduxjs/toolkit'
import { MenuState, MenuTypes } from './types'
const initialState: MenuState = {
    mainMenu: 'Dashboard',
    subMenu: '',
    currentLink: '/dashboard',
    colorDark: true,
}

const reducer: Reducer<MenuState> = (state = initialState, action) => {
    switch (action.type) {
        case MenuTypes.SELECTED_MENU: {
            const newState = { ...state }
            newState.mainMenu = action.payload.mainMenu
            newState.subMenu = action.payload.subMenu
            newState.currentLink = action.payload.currentLink
            return newState
        }

        case MenuTypes.SET_MENU_COLOR: {
            const newState = { ...state }
            newState.colorDark = action.payload.colorDark
            return newState
        }

        case MenuTypes.SET_MENU_TO_INITIAL: {
            return initialState
        }

        default:
            return state
    }
}

export default reducer
